/**
 * Component: Promo banner
 * ------------------------------------------------------------------------------
 * Script used to append a promotional banner to the plp product card grid.
 *
 * @namespace promoBanner
 */
import breakpoints from '~/helpers/breakpoints';
import promoBannerTemplate from '~/components/templates/collection--promo-banner';
/**
 * DOM selectors.
 */

const selectors = {
  productCard: '[js-promo-banner="productCard"]',
  container: '[js-promo-banner="container"]'
};
const {
  hasPromoBanner,
  desktopPosition,
  mobilePosition
} = theme.promoBanner;
const {
  productsPerRowDesktop,
  productsPerRowMobile
} = bcSfFilterConfig.custom;
/**
 * Set promotional banner script.
 */

export default (() => {
  /**
   * DOM node selectors.
   */
  let nodeSelectors;

  function setNodeSelectors() {
    nodeSelectors = {
      productCard: document.querySelectorAll(selectors.productCard)
    };
  }
  /**
   * Appends banner to product grid.
   */


  function appendBanner() {
    if (!hasPromoBanner || nodeSelectors.productCard.length === 0) {
      return;
    }

    let productCardIndex = 0;
    const lastItemIndex = nodeSelectors.productCard.length - 1;

    if (window.matchMedia("(min-width: ".concat(breakpoints.medium, ")")).matches) {
      productCardIndex = productsPerRowDesktop * desktopPosition - productsPerRowDesktop;
    } else {
      productCardIndex = productsPerRowMobile * mobilePosition - productsPerRowMobile;
    }

    if (productCardIndex > lastItemIndex) {
      nodeSelectors.productCard[lastItemIndex].insertAdjacentHTML('afterend', promoBannerTemplate(theme.promoBanner));
      return;
    }

    nodeSelectors.productCard[productCardIndex].insertAdjacentHTML('beforebegin', promoBannerTemplate(theme.promoBanner));
  }
  /**
   * Check if promo banner has already been loaded for boost.
   */


  function isBannerLoaded() {
    const promoBanner = document.querySelectorAll(selectors.container);
    return promoBanner.length > 0;
  }
  /**
   * Entry function.
   */


  function setPromoBanner() {
    if (isBannerLoaded()) {
      return;
    }

    setNodeSelectors();
    appendBanner();
  }
  /**
   * Initialise component.
   */


  function init() {
    exposePromoBanner();
    setPromoBanner();
  }
  /**
   * Expose promo banner functionality to boost.
   */


  function exposePromoBanner() {
    theme.promoBanner.init = () => {
      setPromoBanner();
    };
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});